import React from 'react';
import EmptyState from './EmptyState';
import { TableSkeleton } from './Skeleton';

export default function Table({ columns, rows, renderRow, loading, emptyMessage, emptyIcon, emptyDescription }) {
  if (loading) {
    return <TableSkeleton rows={4} columns={(columns || []).length || 4} />;
  }

  if (!rows || rows.length === 0) {
    return (
      <EmptyState
        icon={emptyIcon}
        title={emptyMessage || 'Nenhum dado encontrado'}
        description={emptyDescription}
      />
    );
  }

  return (
    <div className="table-scroll max-w-[calc(100vw-1.5rem)] overflow-x-auto rounded-card border border-border lg:max-w-none">
      <table className="min-w-[720px] text-sm lg:min-w-full">
        <thead className="bg-surface2 text-zinc-300">
          <tr>
            {(columns || []).map(column => (
              <th key={column.key || column} className="px-3 py-2.5 text-left text-xs font-semibold uppercase tracking-wide">
                {column.label || column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {(rows || []).map((row, index) => {
            if (renderRow) {
              return renderRow(row, index);
            }
            
            // Default render if no renderRow provided
            return (
              <tr key={row.id || index} className="border-t border-border transition-colors duration-150 hover:bg-surface2">
                {(columns || []).map(column => (
                  <td key={column.key || column} className="px-3 py-2">
                    {column.render ? column.render(row) : row[column.key || column]}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

